<template>
    <div class="footer">
        <ul class="contact-list">
            <li><a @click="checkImg('1-fotter-1.png')">营业执照</a></li>
            <li><a @click="navigateTo('/about','contact')">客服中心</a></li>
            <li><a @click="navigateTo('/about','contact')">投诉举报</a></li>
            
            <li><a @click="windowOpen('/agreement/permit_1.html','treaty')">用户协议</a></li> 
            <li><a @click="windowOpen('/agreement/privacy_2.html','treaty')">隐私政策</a></li>
            <li><a @click="navigateTo('/notice',null)">公告声明</a></li>
            <li><a @click="navigateTo('/about','recruit')">精英招聘</a></li>
            <li><a @click="navigateTo('/about','contact')">联系我们</a></li>
        </ul>
        <p class="record-list mt30">
            <span><a>陕icp备 17015012号-9<i></i></a></span>
            <span><a @click="windowOpen('https://beian.mps.gov.cn/#/query/webSearch','webUrl')"><img src="@/assets/img/security.png">陕公网安备 61011302001981号<i></i></a></span>
            <!-- <span><a>网络安全证书<i></i></a></span> -->
            <span><a @click="checkImg('1-fotter-2.png')">增值电信业务经营许可证 陕B2-20240107<i></i></a></span>
            <span><a @click="checkImg('1-fotter-3.png')">网络文化经营许可证 陕网文（2023）0299-010号<i></i></a></span>
            <span><a @click="checkImg('1-fotter-4.png')">广播电视节目制作许可证（陕）字第02264号</a></span>
        </p>
        
        <p class="record-list">
            <span><a @click="checkImg('1-fotter-5.png')">营业性演出许可证 610000120450<i></i></a></span>
            <span><a @click="checkImg('1-fotter-6.png')">预包装食品经营备案编号YB26199040366351<i></i></a></span>
            <span><a>药品医疗器械网络信息服务备案（陕）网药械信息备字（2024）00000 号<i></i></a></span>
            <span><a>互联网宗教信息服务许可证陕（2024）00000</a></span>
        </p>
        
        <p class="record-list">
            <span><a @click="windowOpen('https://www.12377.cn/','webUrl')">中国互联网举报中心<i></i></a></span>
            <span><a @click="windowOpen('https://jbts.mct.gov.cn/','webUrl')">全国文化和旅游市场网上举报投诉处理系统<i></i></a></span>
            <span><a>违法和不良信息举报电话：029-81211266<i></i></a></span>
            <span><a>青少年守护专线：029-81211266<i></i></a></span>
            <span><a>侵权投诉邮箱：kuliao@kuliao.im</a></span>
        </p>

        
        <el-dialog :visible.sync="dialogVisible" @close="formClear" width="35%" align="center"  class="footerDialog" :show-close="false" append-to-body>
            <img :src="`${require('@/assets/img/'+imgUrl)}`" v-if="imgUrl">
        </el-dialog>
    </div>
</template>
<script>
    // import bus from "@/utils/bus";
export default {
    data() {
        return {
            imgUrl:"",
            dialogVisible:false
        };
    },
    components: {
    },
    computed: {
    },
    methods: {
        //弹出层是否显示  营业执照、增值电信业务经营许可证、网络文化经营许可证、广播电视节目制作许可证号、营业性演出许可证、预包装食品经营备案编号
        checkImg(obj){
            if(obj){
                this.dialogVisible = true;
                this.imgUrl = obj;
            }
        },
        //关闭弹出层
        formClear() {
            this.dialogVisible = false;
            this.imgUrl = null;
        },
        //打开先窗口跳转页面 陕公网安备、中国互联网举报中心、全国文化和旅游市场网上举报投诉处理系统
        windowOpen(str,type){
            if(type === "treaty"){ //打开隐私协议和服务政策窗口
                let develop = "httP://172.16.0.86";  //开发环境
                let testing = "httP://10.0.105.61";  //测试环境
                let production = "httPs://im.kuliao.com";  //生产环境
                let resultUrl = production + str;
                window.open(resultUrl,"_blank")
            }else{
                window.open(str,"_blank")
            }
        },
        //点击菜单，跳转相应的页面
        navigateTo(path,anchor){
            if(this.$route.path===path){
                //在同一页面进行跳转
                if(this.$route.query.anchor === anchor){
                    this.$router.go(0)  //刷新页面，避免跳转地址相同报错
                }else{
                    this.$router.push({path,query:{anchor}})
                }
            }else{
                //跳转不同页面
                if(anchor){
                    this.$router.push({path,query:{anchor}})
                }else{
                    this.$router.push({path,query:null})
                }
            }
        }
    },
    mounted() {
        // bus.$on('allowOuterScroll',()=>{
        //     document.body.style.overflow='auto'//允许外层滚动
        // })
        // bus.$on('disableOuterScroll',()=>{
        //     document.body.style.overflow='hidden'//禁止外层滚动
        // })
    }
};
</script>
<style scoped>
.footer {
    padding: 50px 0 60px;
    width: 100%;
	height: 218px;
    font-size: 14px!important;
    color: #fff;
	background-color: #262626;
    box-sizing: border-box;
    cursor: pointer;
}
.footer ul,.footer li,.footer p,.footer span{
    width: auto;
    height: auto;
}
.footer .contact-list{
    display: flex;
    justify-content: center;
    align-items: center;
}
.footer .contact-list li{
    margin-right: 30px;
    font-size: 16px;
}
.footer .contact-list li a{
    color: #c8c8cc;
}
.footer .contact-list li a:hover,.record-list span a:hover{
    color: #ffffff;
}
.footer .contact-list li:last-child{
    margin-right: 0;
}
.footer .record-list{
    margin-bottom: 15px;
    text-align: center;
}
.footer .record-list span{
    font-size: 14px;
}
.footer .record-list span a{
	color: #969699;
}
.footer .record-list span img{
    display: inline-block;
    margin-right: 8px;
}
.footer .record-list span i{
    margin: -2px 7px;
    width: 2px;
    height: 13px;
    background: #969699;
    box-sizing: border-box;
}
.footerDialog >>> .el-dialog{
    margin-top: 9vh!important;
}
.footerDialog >>> .el-dialog .el-dialog__header{
    padding: 0;
}
.footerDialog >>> .el-dialog .el-dialog__body{
    padding: 0px;
}
.footerDialog img{
    width: 100%;
}
</style>
